// Announcement bar slider
$(document).ready(function () {
  const slides = document.querySelectorAll(".announcement_slider-item");
  let currentIndex = 0;

  function showSlide() {
    slides[currentIndex].style.opacity = 0;
    slides[currentIndex].style.visibility = "hidden";

    currentIndex = (currentIndex + 1) % slides.length;

    setTimeout(() => {
      slides[currentIndex].style.opacity = 1;
      slides[currentIndex].style.visibility = "visible";
    }, 200);
  }

  setInterval(showSlide, 6000);
});

// Header fixed
$(window).scroll(function () {
  let scroll = $(window).scrollTop();
  if (scroll >= 60) {
    $('body').addClass("fixed");
  } else {
    $('body').removeClass("fixed");
  }
});

// Navigation toggle
function openNavbar() {
  $('body').addClass('menu-active no-scroll');
};

function closeNavbar() {
  $('body').removeClass('menu-active no-scroll cart-active')
  $('.header_navbar').removeClass("site-menu--level-2-active site-menu--level-3-active");
}

function searchbar() {
  this.closeNavbar()
  $('body').addClass('menu-active no-scroll');
  setTimeout(() => {
    document.querySelector('.header-search-input').focus();
  }, 100);
}

function openCartbar() {
  $('body').toggleClass('cart-active no-scroll');
  $('body').removeClass('menu-active')
};

// Navbar category dropdown
const menu = document.querySelector(".site-menu");

menu.querySelectorAll("[data-show-level]").forEach((toggle) => {
  const level = toggle.dataset.showLevel;

  toggle.addEventListener("click", (e) => {
    e.preventDefault();
    menu.resetScroll?.(),
      toggle.classList.add(`level-${level}-active`),
      menu.classList.add(`site-menu--level-${level}-active`);
  });
});

menu.querySelectorAll("[data-hide-level]").forEach((button) => {
  const level = button.dataset.hideLevel;

  button.addEventListener("click", (e) => {
    e.preventDefault();
    menu.querySelectorAll(`.level-${level}-active`).forEach((openlevel) => {
      openlevel.classList.remove(`level-${level}-active`);
    }),
      menu.classList.remove(`site-menu--level-${level}-active`);
    console.log("Back clicked, level:", level);
  });
});


// Notification feed
document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.notification_feed-item');
  if (items.length <= 1) return;
  let index = 0;
  setInterval(() => {
    items[index].classList.remove('is-active');
    index = (index + 1) % items.length;
    items[index].classList.add('is-active');
  }, 3000);
});

document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.notification_feed-btn');
    if (!btn) return;

    const feed = btn.closest('.notification_feed');
    if (!feed) return;

    if (!feed.classList.contains('is-medium') && !feed.classList.contains('is-large')) {
      feed.classList.add('is-medium');
    } else {
      feed.classList.toggle('is-large');

      if (feed.classList.contains('is-large')) {
        feed.classList.remove('is-medium');
      } else {

        feed.classList.add('is-medium');
      }
    }
  });
});

// Notification feed close
document.addEventListener('DOMContentLoaded', () => {
  document.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('.notification_feed-close');
    if (!closeBtn) return;

    const feed = closeBtn.closest('.notification_feed');
    if (!feed) return;

    feed.classList.remove('is-large', 'is-medium');
  });
});


// Quantity selector 
$(document).ready(function () {

  function updateMinusButton($wrap) {
    let value = parseInt($wrap.find(".quantity_input").val()) || 1;
    let $minusBtn = $wrap.find(".quantity_minus");

    $minusBtn.prop("disabled", value <= 1);
  }

  $(".quantity_btn").on("click", function () {
    let $button = $(this);
    let $wrap = $button.closest(".quantity_wrap");
    let $input = $wrap.find(".quantity_input");
    let oldValue = parseInt($input.val()) || 1;

    if ($button.data("type") === "plus") {
      $input.val(oldValue + 1);
    } else if ($button.data("type") === "minus" && oldValue > 1) {
      $input.val(oldValue - 1);
    }

    updateMinusButton($wrap);
  });

  $(".quantity_input").on("input", function () {
    let $wrap = $(this).closest(".quantity_wrap");

    this.value = this.value.replace(/[^0-9]/g, '');
    if (this.value === "" || parseInt(this.value) < 1) {
      this.value = 1;
    }

    updateMinusButton($wrap);
  });

});


//  Community section
function getViewPercentage(element) {
  const viewportTop = window.pageYOffset;
  const viewportBottom = viewportTop + window.innerHeight;
  const rect = element.getBoundingClientRect();
  const elementTop = rect.top + window.pageYOffset;
  const elementBottom = elementTop + rect.height;
  if (viewportTop > elementBottom || viewportBottom < elementTop) {
    return { percent: 0, passed: false };
  }
  if (
    (viewportTop < elementTop && viewportBottom > elementBottom) ||
    (elementTop < viewportTop && elementBottom > viewportBottom)
  ) {
    return { percent: 100, passed: elementTop < viewportTop };
  }
  let elementHeightInView = rect.height;
  let passed = false;
  if (elementTop < viewportTop) {
    elementHeightInView -= viewportTop - elementTop;
    passed = true;
  }
  if (elementBottom > viewportBottom) {
    elementHeightInView -= elementBottom - viewportBottom;
    passed = false;
  }
  const percent = Math.round(
    (elementHeightInView / window.innerHeight) * 100
  );
  return { percent, passed };
}
window.addEventListener("scroll", () => {
  const hub = document.querySelector(".community_hub");
  if (!hub) return;
  const { percent, passed } = getViewPercentage(hub);
  if (percent > 50 && passed) {
    hub.classList.add("community_hub--full");
  } else {
    hub.classList.remove("community_hub--full");
  }
});


// Footer Gradient effect
document.addEventListener("DOMContentLoaded", () => {
  const footers = document.querySelectorAll("footer");
  if (!footers.length) return;
  function checkVisibility(footer) {
    const backdrop = footer.querySelector(".footer_backdrop");
    if (!backdrop) return;

    const rect = footer.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (rect.top < windowHeight && rect.bottom > 0) {
      const visibleHeight =
        Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

      const totalHeight = rect.height;

      const percentageVisible =
        (Math.max(0, visibleHeight) / totalHeight) * 100;

      backdrop.style.opacity = `${Math.max(25, percentageVisible)}%`;
    }
  }

  function onUpdate() {
    footers.forEach(checkVisibility);
  }

  window.addEventListener("scroll", onUpdate, { passive: true });
  window.addEventListener("resize", onUpdate);

  onUpdate();
});


document.addEventListener("DOMContentLoaded", () => {
  let modalSplide = null;

  // MAIN SLIDER OPTIONS

  const sliderOptions = {
    perPage: 3,
    gap: "15px",
    arrows: false,
    pagination: true,
    drag: true,
    snap: true,
    perMove: 1,
    rewind: true,
    updateOnMove: true,
    type:"loop",
    trimSpace: false,
    flickPower: 100,
    flickMaxPages: 1,
    focus: 0,
    breakpoints: {
      1024: { perPage: 2 },
      600: { perPage: 1 },
    },
  };

  const splide = new Splide(".video-slider", sliderOptions);
  splide.on("move", () => {
    document
      .querySelectorAll(".video-slider video")
      .forEach((video) => {
        const poster = video.getAttribute("poster");

        video.pause();
        video.currentTime = 0;

        video.removeAttribute("poster");
        video.setAttribute("poster", poster);

        video.load();
      });
  });

  // MODAL SLIDER OPTIONS 

  const sliderOptions2 = {
    type: "slide",
    perPage: 1,
    direction: "ttb",
    height: "100vh",
    arrows: true,
    pagination: true,
    snap: true,
    updateOnMove: true,
    drag: true,
    dragAngleThreshold: 90,
    classes: {
      pagination: "splide__pagination video-gallery-pagination",
      page: "splide__pagination__page video-gallery-page",
    },
  };

  //INNER PRODUCT SLIDER (NO DRAG — IMPORTANT) 

  const productSliderOptions = {
    fixedWidth: "316px",
    perPage: 2,
    perMove: 1,
    updateOnMove: true,
    snap: true,
    drag: true,
    trimSpace: false,
    pagination: false,
    arrows: false,
    flickPower: 100,
    flickMaxPages: 1,
    focus: 0,
    gap: "8px",
    padding: {
      right: "10px"
    },
    breakpoints: {
      1399: {
        perPage: 1
      },
      749: {
        perPage: 2
      },
      599: {
        perPage: 1
      }
    }
  };

  const mainBlock = document.querySelector(".video-block");
  if (mainBlock) initVideoSlider(mainBlock, sliderOptions);

  function initVideoSlider(block, options, isModal = false, startIndex = 0) {
    const sliderEl = block.querySelector(".video-slider");
    if (!sliderEl) return null;

    const cursor = block.querySelector(".drag-cursor");
    const slides = sliderEl.querySelectorAll(".splide__slide");
    const videoContent = block.querySelectorAll(".video-content-inner");

    const splide = new Splide(sliderEl, options);

    // VIDEO HANDLER (SAFE)

    function syncVideos(activeIndex) {

      sliderEl.querySelectorAll("video").forEach(video => {
        video.pause();
        video.currentTime = 0;
      });

      const slideObj = splide.Components.Slides.getAt(activeIndex);
      if (!slideObj) return;

      const activeSlide = slideObj.slide;

      const video = activeSlide.querySelector(
        ":scope > .splide__slide__inner video"
      );

      if (video) {
        video.muted = true;
        video.playsInline = true;
        video.play().catch(() => { });
      }
    }


    // CONTENT HANDLER 
    function syncContent(activeIndex) {
      if (!videoContent.length) return;
      videoContent.forEach((content) => {
        content.classList.toggle(
          "active",
          Number(content.dataset.slideIndex) === activeIndex
        );
      });
    }


    function updateInnerSlider(id) {
      const videoinnerContent = document.querySelectorAll('.video-gallery-content-inner')
      if (!videoinnerContent.length) return;
      videoinnerContent.forEach((content) => {
        content.classList.toggle(
          "active",
          content.dataset.productHandle === id
        );
      });
    }

    // INNER PRODUCT SLIDER INIT

    function initProductSlider(slide) {
      const inner = slide.querySelector(".video-product-slider");
      if (!inner || inner.__splide) return;

      inner.__splide = new Splide(
        inner,
        productSliderOptions
      ).mount();

      inner.__splide.on("moved", () => {
        const activeProductId = inner.querySelector(".splide__slide.is-active").getAttribute('data-product-handle');
        updateInnerSlider(activeProductId)
        $(".video-product-card-img").removeClass("hide")
        $(".video-product-card-content").removeClass("active")
        $(".quick-add").removeClass("show-cart")
      });
      const slides = inner.querySelectorAll(".splide__slide");
      slides.forEach((slide, index) => {
        slide.addEventListener("click", () => {
          if (index !== splide.index) {
            inner.__splide.go(index)
            return;
          }
        });
      });
    }

    // SPLIDE EVENTS

    splide.on("mounted moved active", () => {
      syncVideos(splide.index);
      syncContent(splide.index);
    });
    splide.on("mounted", () => {
      if (startIndex) {
        splide.go(startIndex);
      }
    });

    // FORCE VIDEO PLAY AFTER MOVE 
    splide.on("moved", () => {
      syncVideos(splide.index);
    });

    if (isModal) {
      splide.on("active", (slide) => {
        initProductSlider(slide.slide);
        const activeProductId = slide.slide.querySelector(".splide__slide.is-active").getAttribute('data-product-handle');
        updateInnerSlider(activeProductId)
        slide.slide.addEventListener("click", (e) => {
          console.log(e.target)
          const id = e.target.dataset.productHandle
          const index = e.target.dataset.slideIndex
          if (id) {
            updateInnerSlider(id)
          }
          if (index) {
            const sliderEl = slide.slide.querySelector(".video-product-slider");
            if (!sliderEl) return null;
            sliderEl.__splide.go(Number(index))
          }
        });
      });
    }

    // CLICK → OPEN MODAL

    slides.forEach((slide, index) => {
      slide.addEventListener("click", () => {
        if (isModal) return;

        if (index !== splide.index) {
          splide.go(index);
          return;
        }

        document.body.classList.add("video-modal-open");

        const modalBlock = document.querySelector(
          ".video-gallery-slider-outer"
        );
        if (!modalBlock) return;

        if (!modalSplide) {
          modalSplide = initVideoSlider(
            modalBlock,
            sliderOptions2,
            true,
            index
          );
        } else {
          modalSplide.go(index);
        }
      });
    });

    splide.mount();

    //  DRAG CURSOR (DESKTOP)

    if (cursor && !isModal) {
      sliderEl.addEventListener(
        "mouseenter",
        () => (cursor.style.opacity = 1)
      );
      sliderEl.addEventListener(
        "mouseleave",
        () => (cursor.style.opacity = 0)
      );
      sliderEl.addEventListener("mousemove", (e) => {
        cursor.style.left = `${e.clientX}px`;
        cursor.style.top = `${e.clientY}px`;
      });
    }

    return splide;
  }

  $(".video-gallery-modal__close").click(() => {
    document.body.classList.remove("video-modal-open");
  });
});

//Play / pause - volume on / off
document.addEventListener("click", e => {
  const p = e.target.closest(".playback"),
    v1 = p?.closest(".splide__slide__inner")?.querySelector("video");
  if (v1) {
    v1.paused ? v1.play() : v1.pause();
    p.classList.toggle("playback-play", v1.paused);
    p.classList.toggle("playback-pause", !v1.paused);
  }
  const m = e.target.closest(".volume"),
    v2 = m?.closest(".splide__slide__inner")?.querySelector("video");
  if (v2) {
    v2.muted = !v2.muted;
    m.classList.toggle("volume-off", v2.muted);
    m.classList.toggle("volume-on", !v2.muted);
  }
});

// Read More / Read Less - Multiple Instances
// $('.moreless-button').on('click', function () {
//   const $wrapper = $(this).closest('.readMoreText');
//   // const $moreText = $wrapper.find('.moretext');
//   $wrapper.slideToggle();
//   $(this).text(
//     $(this).text() === 'Read more' ? 'Read less' : 'Read more'
//   );
// });

$('.moreless-button').click(function(e){
  e.preventDefault();
  var a = $(this).prev('.moretext');
  a.toggleClass('open')
   .animate({ height: a.hasClass('open') ? a[0].scrollHeight : 65 }, 200);
  $(this).text(a.hasClass('open') ? 'Read less' : 'Read more');
});

// Footer dropdown for mobile
if ($(window).width() <= 767) {
  $('.footer_dropdown').hide();
  $(".common_click").on("click", function () {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".footer_dropdown").slideUp(500);
    } else {
      $(".common_click").removeClass("active");
      $(this).addClass("active");
      $(".footer_dropdown").slideUp(500);
      $(this).siblings(".footer_dropdown").slideDown(500);
    }
  });
}

// Coleection page script
$(document).ready(function () {
  $('.colors_product input[type="radio"]').on('change', function () {
    var $card = $(this).closest('.product_card');
    var index = $(this).data('index');
    var shadeName = $(this).data('name');

    var $images = $card.find('.varient-img img');
    $images.removeClass('active');
    $images.eq(index).addClass('active');

    $card.find('.varient_data').text(shadeName);
  });
});

$(document).ready(function () {
  $('.productSelect').on('change', function () {
    var $card = $(this).closest('.product_card');
    var $selectedOption = $(this).find('option:selected');
    var index = $selectedOption.data('index');
    var shadeName = $selectedOption.text();
    $card.find('.product_option').text(shadeName);
    var $images = $card.find('.varient-img img');
    $images.removeClass('active');
    if (index >= 0 && index < $images.length) {
      $images.eq(index).addClass('active');
    } else {
      $images.eq(0).addClass('active');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.tabs_mobile_scroll');
  const leftBtn = document.querySelector('.left_arrows');
  const rightBtn = document.querySelector('.right_arrows');
  const STEP = 200;

  if (!container || !leftBtn || !rightBtn) return;

  const items = Array.from(container.querySelectorAll('.tabs_fills'));

  function updateButtons() {
    const containerRect = container.getBoundingClientRect();
    const firstItemRect = items[0].getBoundingClientRect();
    const lastItemRect = items[items.length - 1].getBoundingClientRect();

    leftBtn.classList.toggle('disabled', firstItemRect.left >= containerRect.left);

    rightBtn.classList.toggle('disabled', lastItemRect.right <= containerRect.right);
  }

  leftBtn.addEventListener('click', () => {
    container.scrollBy({ left: -STEP, behavior: 'smooth' });
  });

  rightBtn.addEventListener('click', () => {
    container.scrollBy({ left: STEP, behavior: 'smooth' });
  });

  container.addEventListener('scroll', updateButtons);
  window.addEventListener('resize', updateButtons);
  window.addEventListener('load', () => setTimeout(updateButtons, 50));
});



//Featured product banner
$(document).ready(function () {
  $(".featured_product-banner").on("click",".video-product-card-content", function (e) {
      if ($(e.target).closest("input, label, select").length) return;
      const $card = $(this).closest(".card-content-wrapper-inner");
      $(this).toggleClass("active");
      $card.find(".quick-add").toggleClass("show-cart");
    }
  );
});


//Gallery product banner
$(document).ready(function () {
  $(document).on("click", ".card-information-data .video-product-card-content", function (e) {
    if ($(e.target).closest("input, label, select, button, a").length) return;
    if (window.matchMedia("(max-width: 1199px)").matches) {
      const $card = $(this).closest(".card-content-wrapper-inner");
      $(this).toggleClass("active");
      $card.find(".quick-add").toggleClass("show-cart");
      $card.find(".video-product-card-img").toggleClass("hide");
    }
  });
});


//Data Title Change
document.querySelectorAll('.change-purchase-variants input, .change-purchase-variants select').forEach(el =>
  el.addEventListener('change', () => {
    const wrap = el.closest('.change-purchase-variants');
    const data = el.tagName === 'SELECT'
      ? el.selectedOptions[0].dataset
      : el.dataset;
    ['price','size','title','value'].forEach(k => {
      const t = wrap?.querySelector('.variant-' + k);
      if (t && data[k]) t.textContent = data[k];
    });
  })
);

//Featured product Slider
(() => {
  const splideEl = document.querySelector('.featured_product-banner.splide');
  if (!splideEl) return;
  const track  = splideEl.querySelector('.splide__track');
  const cursor = splideEl.querySelector('.drag-cursor');
  new Splide(splideEl, {
    perPage: 1,
    autoplay: true,
    arrows: false,
    pagination: true,
    drag: true,
    noDrag: 'input, label, select, button',
    dragMinThreshold: {
      mouse: 10,
      touch: 15
    }
  }).mount();
  if (!cursor || !track) return;
  track.addEventListener("mouseenter", () => cursor.style.opacity = 1);
  track.addEventListener("mouseleave", () => cursor.style.opacity = 0);
  track.addEventListener("mousemove", e => {
    cursor.style.left = e.clientX + "px";
    cursor.style.top  = e.clientY + "px";
  });
})();


$(document).ready(function () {
    $('.product_detail-tabs').each(function () {
        let $this = $(this);
        $this.find('.product_detail-tabs--controls button').click(function () {
            let tab_id = $(this).attr('data-tab');

            $this.find('.product_detail-tabs--controls button').removeClass('is-active');
            $this.find('.product_detail-tabs--content').removeClass('is-active');

            $(this).addClass('is-active');
            $this.find("#" + tab_id).addClass('is-active');
        });
    });
});


document.addEventListener('DOMContentLoaded', function () {
  const sliderEl = document.querySelector('.products-slider');
  if (!sliderEl) return;

  const cursor = sliderEl.querySelector('.drag-cursor');
  const isModal = sliderEl.closest('.modal'); 

  const splide = new Splide(sliderEl, {
    type       : 'slide',
    perPage    : 1,
    gap        : '16px',
    arrows     : false,
    pagination : true,
    drag       : true,

  }).mount();

  if (cursor && !isModal && window.matchMedia('(hover: hover)').matches) {
    sliderEl.addEventListener('mouseenter', () => {
      cursor.style.opacity = 1;
    });

    sliderEl.addEventListener('mouseleave', () => {
      cursor.style.opacity = 0;
    });

    sliderEl.addEventListener('mousemove', (e) => {
      cursor.style.left = `${e.clientX}px`;
      cursor.style.top = `${e.clientY}px`;
    });
  }
});


$(document).ready(function () {

  function updateBenefits() {
    $('.buying_option').each(function () {
      const $radio = $(this).find('input[type="radio"]');
      const $benefits = $(this).find('.product-benefits');

      if ($benefits.length) {
        $benefits.toggle($radio.is(':checked'));
      }
    });
  }

  updateBenefits();

  $('input[name="sellingplan_option"]').on('change', function () {
    updateBenefits();
  });




});


// Product benefits tabs Slider
(() => {
  const splideEl = document.querySelector('.product_benefis-slider');
  if (!splideEl) return;
  const track  = splideEl.querySelector('.splide__track');
  const cursor = splideEl.querySelector('.drag-cursor');
  new Splide(splideEl, {
    perPage: 3,
    autoplay: true,
    arrows: false,
    pagination: false,
    drag: true,
    dragMinThreshold: {
      mouse: 10,
      touch: 15
    },
    breakpoints: {
      992: { perPage: 2 },
      600: { perPage: 1 },
    },
  }).mount();
  if (!cursor || !track) return;
  track.addEventListener("mouseenter", () => cursor.style.opacity = 1);
  track.addEventListener("mouseleave", () => cursor.style.opacity = 0);
  track.addEventListener("mousemove", e => {
    cursor.style.left = e.clientX + "px";
    cursor.style.top  = e.clientY + "px";
  });
})();


// Product how to use tabs Slider
(() => {
  const splideEl = document.querySelector('.product_how_to_use_wrap-slider');
  if (!splideEl) return;
  const track  = splideEl.querySelector('.splide__track');
  const cursor = splideEl.querySelector('.drag-cursor');
  new Splide(splideEl, {
    perPage: 3,
    autoplay: true,
    arrows: false,
    pagination: false,
    drag: true,
    dragMinThreshold: {
      mouse: 10,
      touch: 15
    },
    breakpoints: {
      992: { perPage: 2 },
      600: { perPage: 1 },
    },
  }).mount();
  if (!cursor || !track) return;
  track.addEventListener("mouseenter", () => cursor.style.opacity = 1);
  track.addEventListener("mouseleave", () => cursor.style.opacity = 0);
  track.addEventListener("mousemove", e => {
    cursor.style.left = e.clientX + "px";
    cursor.style.top  = e.clientY + "px";
  });
  
})();


// Accordions
$(document).on("click", ".accordion_header", function () {
    $(".accordion").not($(this).parent()).removeClass("active").find(".accordion_content").slideUp();
    $(this).parent().toggleClass("active");
    $(this).next(".accordion_content").slideToggle(200);
});


// upsells variant select
$(document).ready(function () {

    $(document).on("click", ".cart-upsells-item-selected-variant", function (e) {
        e.stopPropagation();

        const $wrapper = $(this).closest(".cart_upsells-item-select");

        $(".cart_upsells-item-select-items").not(
            $wrapper.find(".cart_upsells-item-select-items")
        ).hide();

        $(".cart-upsells-item-selected-variant").not(this).removeClass("active");

        $(this).toggleClass("active");
        $wrapper.find(".cart_upsells-item-select-items").toggle();
    });

    $(document).on("click", ".cart_upsells-item-option", function (e) {
        e.stopPropagation();

        const selectedValue = $(this).text();
        const $wrapper = $(this).closest(".cart_upsells-item-select");

        $wrapper.find(".cart-upsells-item-selected-variant").text(selectedValue);
        $wrapper.find(".cart_upsells-item-option").removeClass("selected");
        $(this).addClass("selected");

        $wrapper.find(".cart_upsells-item-select-items").hide();
        $wrapper.find(".cart-upsells-item-selected-variant").removeClass("active");
    });

    $(document).click(function () {
        $(".cart_upsells-item-select-items").hide();
        $(".cart-upsells-item-selected-variant").removeClass("active");
    });

});

// Cart upsell item add
$(document).on("click", ".cart_upsells-item-add", function () {
    const $btn = $(this);
    if ($btn.hasClass("added")) return;
    $btn.addClass("added");
    setTimeout(function () {
        $btn.removeClass("added");
    }, 2000);
});







$(document).ready(function () {

  /* ==============================
     ADD TO CART
  ============================== */


  $(document).on("click", ".Add-to-Cart", function (e) {
  e.preventDefault();

  const $btn = $(this);
  const originalBtnText = $btn.html();

  const variantId = $btn.data("variant-id");
  const selectedOption = $('input[name="sellingplan_option"]:checked').val();
  let sellingPlanId = null;

  if (selectedOption === 'subscription') {
    sellingPlanId = $('select[name="selling_plan"]').val();
  }

  let payload = {
    id: variantId,
    quantity: 1
  };

  if (sellingPlanId) {
    payload.selling_plan = sellingPlanId;
  }

  // UI loading state
  $btn.prop("disabled", true).html("Adding...");

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: JSON.stringify(payload),
    contentType: "application/json",
    dataType: "json",
    success: function (response) {
    $btn.html(originalBtnText).prop('disabled', false);

        // Fetch updated cart & open sidebar
        getCart(function () {
          setTimeout(function () {
            openSidebarCart();
          }, 100);
        });
    },
    error: function (err) {
        console.error('Error add to cart:', error);
        $btn.html(originalBtnText).prop('disabled', false);
        alert('Error adding product to cart. Please try again.');
    }
  });
});

  /* ==============================
     OPEN SIDEBAR CART
  ============================== */
  function openSidebarCart() {

    $('body').addClass('cart-active no-scroll');
 
  }

  /* ==============================
     GET CART
  ============================== */
  function getCart(callback) {
    $.ajax({
      url: '/cart.js',
      method: 'GET',
      dataType: 'json',
      success: function (cart) {
        renderCart(cart);
        updateCartSummary(cart);
        if (typeof callback === 'function') callback();
      },
      error: function (xhr, status, error) {
        console.error('Error fetching cart:', error);
      }
    });
  }

  /* ==============================
     UPDATE CART SUMMARY
  ============================== */
  function updateCartSummary(cart) {
    $('#cartCount').text(cart.item_count);
     $('.cartSubtotalCount, .item-count').text(cart.item_count);
    $('.cart_footer-subtotal-value').text(`$${(cart.total_price / 100).toFixed(2)}`);

    if (cart.item_count === 0) {
      $('.cart_block').addClass('cart_block-empy');
      $('#cartBtn, #checkoutBtn').addClass('disabled');
      $('#cartCount').hide();
    } else {
      $('.cart_block').removeClass('cart_block-empy');
      $('#cartBtn, #checkoutBtn').removeClass('disabled');
      $('#cartCount').show();
    }
  }

  /* ==============================
     RENDER CART
  ============================== */
  function renderCart(cart) {
    const cartContainer = $('#sidebarCart');

    if (cart.item_count === 0) {
      
      cartContainer.html('<p class="my-2 text-center">YOUR SHOPPING CART IS EMPTY</p>');
      return;
    }

    let cartItemsHTML = '';

    $.each(cart.items, function (index, item) {

        let sellingPlanHTML = '';

  if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
      sellingPlanHTML = `
        <div class="cart-selling">
          <small>${item.selling_plan_allocation.selling_plan.name}</small>
        </div>
      `;
    }
      cartItemsHTML += `
         <div class="cart_item" data-variant-id="${item.variant_id}">
                        <a href="${item.url}" class="cart_item-image-wrap">
                            <img src="${item.image}" alt="${item.title}"  class="cart_item-image" alt="Cart product" width="160" height="230">
                        </a>
                        <div class="cart_item-content">
                            <div class="cart_item-details">
                                <div class="no-bullets">
                                    <a href="${item.url}" class="cart_item-title">${item.title}
                                     </a>
                                     ${sellingPlanHTML}
                                    
                                </div>
                                
                                <div class="cart_item-price">
                                  <span class="final-price">$${(item.original_line_price / 100).toFixed(2)}</span>
                                </div>
                            </div>
                            <div class="cart_item-footer">
                                <div class="quantity_wrap">
                                    <button type="button" class="quantity_btn quantity_minus dec-item" data-line-key="${item.key}" data-variant-id="${item.variant_id}" data-type="minus" aria-label="Minus">
                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-minus" fill="none" viewBox="0 0 10 2">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 110 1H1A.5.5 0 01.5 1z" fill="currentColor">
                                            </path>
                                        </svg>
                                    </button>
                                      <input
                                          type="text"
                                          class="quantity_input cart-quantity-input"
                                          data-variant-id="${item.variant_id}"
                                          data-line-key="${item.key}"
                                          value="${item.quantity}"
                                          min="1">
                                    <button type="button" class="quantity_btn quantity_plus inc-item"  data-line-key="${item.key}" data-variant-id="${item.variant_id}" data-type="plus" aria-label="Plus">
                                        <svg class="icon icon-plus" width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <line y1="5.5" x2="11" y2="5.5" stroke="#222222"></line>
                                            <line x1="5.5" y1="11" x2="5.5" y2="2.18557e-08" stroke="#222222"></line>
                                        </svg>
                                    </button>
                                </div>
                                <button type="button" class="cart_item-remove" data-line-key="${item.key}" data-variant-id="${item.variant_id}">Remove</button>
                            </div>
                        </div>
                    </div>`;
    });

    cartContainer.html(cartItemsHTML);
  }

  /* ==============================
     UPDATE CART ITEM
  ============================== */

function updateCart(lineKey, quantity) {
  $.ajax({
    url: '/cart/change.js',
    method: 'POST',
    dataType: 'json',
    data: {
      id: lineKey,   // ✅ MUST be item.key
      quantity: quantity
    },
    success: function (cart) {
      renderCart(cart);
      updateCartSummary(cart);
    },
    error: function (xhr, status, error) {
      console.error('Error updating cart:', error);
    }
  });
}

  /* ==============================
     QUANTITY CONTROLS
  ============================== */

  $(document).on('click', '.inc-item', function () {
  const lineKey = $(this).data('line-key');
  const $input = $(`.cart-quantity-input[data-line-key="${lineKey}"]`);
  let qty = parseInt($input.val(), 10) + 1;

  $input.val(qty);
  updateCart(lineKey, qty);
});

$(document).on('click', '.dec-item', function () {
  const lineKey = $(this).data('line-key');
  const $input = $(`.cart-quantity-input[data-line-key="${lineKey}"]`);
  let qty = parseInt($input.val(), 10);

  if (qty > 1) {
    qty--;
    $input.val(qty);
    updateCart(lineKey, qty);
  }
});

$(document).on('input', '.cart-quantity-input', function () {
  const lineKey = $(this).data('line-key');
  let qty = parseInt($(this).val(), 10);

  if (qty > 0) {
    updateCart(lineKey, qty);
  }
});


$(document).on('click', '.cart_item-remove', function () {
  const lineKey = $(this).data('line-key');
  if (!lineKey) return;

  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: {
      id: lineKey,   // ✅ item.key only
      quantity: 0
    },
    success: function (cart) {
      renderCart(cart);
      updateCartSummary(cart);
    },
    error: function () {
      console.error('Failed to remove item');
    }
  });
});
  getCart();

});




// pagination
   document.addEventListener("DOMContentLoaded", function() { 
         var endlessScroll = new Ajaxinate({
         container: '#AjaxinateContainer',
         pagination: '#AjaxinatePagination',
         //callback : sliderafterajax
       });
   
    
   });

/// collection filters
document.addEventListener("DOMContentLoaded", function () {
  const filters = document.querySelectorAll('input[name="quick_filters"]');
  const products = document.querySelectorAll('.product-item');

  // ---------- Get base collections URL ----------
  const baseCollectionURL = "/collections";

  // ---------- Apply filter ----------
  function applyFilter(selected) {
    products.forEach(product => {
      const productCollections = product.dataset.collections
        ? product.dataset.collections.split(',')
        : [];

      if (selected === 'all') {
        product.style.display = 'block';
      } else if (productCollections.includes(selected)) {
        product.style.display = 'block';
      } else {
        product.style.display = 'none';
      }
    });
  }

  // ---------- Update URL ----------
  function updateURL(selected) {
    if (selected === 'all') {
      history.pushState({}, "", baseCollectionURL);
    } else {
      history.pushState({}, "", `${baseCollectionURL}/${selected}`);
    }
  }

  // ---------- Detect collection from URL on load ----------
  let selectedFromURL = null;
  const pathParts = window.location.pathname.split('/');

  if (pathParts.includes('collections') && pathParts.length > 2) {
    selectedFromURL = pathParts[pathParts.length - 1];
  }

  if (selectedFromURL) {
    filters.forEach(filter => {
      if (filter.value === selectedFromURL) {
        filter.checked = true;
        applyFilter(selectedFromURL);
      }
    });
  }

  // ---------- On filter change ----------
  filters.forEach(filter => {
    filter.addEventListener('change', function () {
      applyFilter(this.value);
      updateURL(this.value);
    });
  });
});


// ---------- Close / Reset ----------
document.addEventListener("click", function (e) {
  if (!e.target.matches(".icon-close")) return;

  e.preventDefault();
  e.stopPropagation();

  const filters = document.querySelectorAll('input[name="quick_filters"]');
  const products = document.querySelectorAll('.product-item');

  // Reset all filters
  filters.forEach(filter => filter.checked = false);

  // Show all products
  products.forEach(product => product.style.display = 'block');

  // Reset URL
  history.pushState({}, "", "/collections/all");
});


// search filter
 document.addEventListener("DOMContentLoaded", function () {
        const searchProducts = document.querySelectorAll('.search-products');
        const allProducts = document.querySelectorAll('.allproducts');

        if (searchProducts.length > 0) {
            allProducts.forEach(product => {
                product.style.display = 'none';
            });
        }
    }); 














